import { render } from "./IndicadorFecha.vue?vue&type=template&id=616fcbec&scoped=true"
import script from "./IndicadorFecha.vue?vue&type=script&lang=js"
export * from "./IndicadorFecha.vue?vue&type=script&lang=js"

import "./IndicadorFecha.vue?vue&type=style&index=0&id=616fcbec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616fcbec"]])

export default __exports__